export enum CollaborationState {
  default = 'default',
  declined = 'declined',
  active = 'active',
  invited = 'invited',
  disable = 'disable',
  disabled = 'disabled',
  deleted = 'deleted',
  reactivated = 'reactivated',
  delete = 'delete'
}

export default class Collaborator {
  public constructor (init?:Partial<Collaborator>) {
    Object.assign(this, init)
  }

  public id: string | null = null;
  public ownerId: string | null = null;
  public projectId: string | null = null;
  public collaboratorUserId: string | null = null;
  public collaboratorMail: string | null = null;
  public collaboratorSalary: number | null = null;
  public collaboratorProjectId: string | null = null;
  public state: CollaborationState = CollaborationState.default
}
